//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/ns-icon";
export default {
  name: "NsDonationReceipt",
  components: { NsIcon },
  props: {
    /**
     * Transaction description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Transaction receiptId
     */
    receiptId: {
      type: String,
      default: ""
    },
    /**
     * Transaction amount
     */
    amount: {
      type: String,
      default: ""
    },
    /**
     * Transaction transaction date
     */
    transactionDate: {
      type: String,
      default: ""
    },
    /**
     * Transaction cardLast4
     */
    cardLast4: {
      type: String,
      default: ""
    },
    /**
     * Back button Text
     */
    backText: {
      type: String,
      default: "Back to donation form"
    },
    /**
     * Success Message above receipt
     */
    successMessage: {
      type: String,
      default: "Your payment was successful!"
    },
    /**
     * 'Receipt From' translation
     */
    receiptFromText: {
      type: String,
      default: "Receipt from"
    },
    /**
     * 'Receipt' translation'
     */
    receiptLabel: {
      type: String,
      default: "Receipt"
    },
    /**
     * 'Amount Paid' translation
     */
    amountPaidLabel: {
      type: String,
      default: "Amount Paid"
    },
    /**
     * 'Date Paid' translation
     */
    datePaidLabel: {
      type: String,
      default: "Date Paid"
    },
    /**
     * 'Payment Method' translation
     */
    paymentMethodLabel: {
      type: String,
      default: "Payment Method"
    },
    /**
     * 'Summary' translation
     */
    summaryLabel: {
      type: String,
      default: "Summary"
    },
    /**
     * 'Nu Skin Donation' translation
     */
    nuskinDonationLabel: {
      type: String,
      default: "Nu Skin Donation"
    },
    /**
     * 'Amount charged' translation
     */
    amountChargedLabel: {
      type: String,
      default: "Amount charged"
    },
    /**
     * Questions at bottom of receipt
     */
    questionsMessage: {
      type: String,
      default: "If you have any questions, call us at +1 801-345-0157."
    },
    /**
     * Email message at bottom of receipt
     */
    sentToEmailMessage: {
      type: String,
      default: "A copy of this receipt has been sent to your email."
    }
  },
  methods: {
    handleBackClick() {
      this.$emit("back");
    },
    handlePrint() {
      window.print();
    }
  }
};
